<template>
  <div>
    <Section
      :heading="type === 'edit' ? 'Edit Manufacturer' : 'Add Manufacturer'"
    />
    <div class="grid gap-6 sm:gap-4">
      <AppCard
        :mode="mode"
        title="Name Settings"
        :isCenter="false"
        :isSmallTitle="true"
      >
        <template #body>
          <div class="grid grid-cols-3 gap-x-3 gap-y-4 sm:grid-cols-1 sm:gap-4">
            <AppInput
              :mode="mode"
              id="name"
              title="Name"
              placeholder="Not specified"
              v-model="manufacturer.mfr.mfr"
            />
            <AppInput
              :mode="mode"
              id="company"
              title="Company"
              placeholder="Not specified"
              v-model="manufacturer.mfr.company"
            />
            <AppInput
              :mode="mode"
              id="abbr"
              title="Abbr"
              placeholder="Not specified"
              v-model="manufacturer.mfr.abbr"
            />
          </div>
        </template>
      </AppCard>
      <AppCard
        :mode="mode"
        title="Address Information"
        :isCenter="false"
        :isSmallTitle="true"
      >
        <template #body>
          <div class="grid grid-cols-3 gap-x-3 gap-y-4 sm:grid-cols-1 sm:gap-4">
            <AppSelect
              :mode="mode"
              title="Country"
              v-model="manufacturer.mfr.country"
            >
              <template #options>
                <option value="">Country</option>
                <option
                  v-for="(country, key) in countries"
                  :value="country.code"
                  :key="key"
                  :selected="country.code === manufacturer.mfr.country"
                >
                  {{ country.country }}
                </option>
              </template>
            </AppSelect>
            <AppInput
              :mode="mode"
              id="zip"
              title="Zip"
              placeholder="Not specified"
              v-model="zip"
            />
            <AppSelect
              :mode="mode"
              title="State"
              v-model="manufacturer.mfr.state"
              :isDisabled="states.length === 0"
            >
              <template #options>
                <option value="">State</option>
                <option
                  v-for="(state, key) in states"
                  :value="state.code"
                  :key="key"
                  :selected="state.code === manufacturer.mfr.state"
                >
                  {{ state.name }}
                </option>
              </template>
            </AppSelect>
          </div>
        </template>
      </AppCard>
      <AppCard
        :mode="mode"
        title="Sponsors Information"
        :isCenter="false"
        :isSmallTitle="true"
      >
        <template #body>
          <div class="grid grid-cols-3 gap-x-3 gap-y-4 sm:grid-cols-1 sm:gap-4">
            <AppInput
              :mode="mode"
              id="sponsor1_name"
              title="Sponsor 1 name"
              placeholder="Not specified"
              v-model="manufacturer.mfr.sponsor1_name"
            />
            <AppInput
              :mode="mode"
              id="sponsor1_url"
              type="url"
              title="Sponsor 1 URL"
              placeholder="Not specified"
              v-model="manufacturer.mfr.sponsor1_url"
            />
            <AppInput
              :mode="mode"
              id="sponsor1_image"
              title="Sponsor 1 image"
              placeholder="Not specified"
              v-model="manufacturer.mfr.sponsor1_image"
            />
            <AppInput
              :mode="mode"
              id="sponsor2_name"
              title="Sponsor 2 name"
              placeholder="Not specified"
              v-model="manufacturer.mfr.sponsor2_name"
            />
            <AppInput
              :mode="mode"
              id="sponsor2_url"
              type="url"
              title="Sponsor 2 URL"
              placeholder="Not specified"
              v-model="manufacturer.mfr.sponsor2_url"
            />
            <AppInput
              :mode="mode"
              id="sponsor2_image"
              title="Sponsor 2 image"
              placeholder="Not specified"
              v-model="manufacturer.mfr.sponsor2_image"
            />
            <AppInput
              :mode="mode"
              id="sponsor3_name"
              title="Sponsor 3 name"
              placeholder="Not specified"
              v-model="manufacturer.mfr.sponsor3_name"
            />
            <AppInput
              :mode="mode"
              id="sponsor3_url"
              type="url"
              title="Sponsor 3 URL"
              placeholder="Not specified"
              v-model="manufacturer.mfr.sponsor3_url"
            />
            <AppInput
              :mode="mode"
              id="sponsor3_image"
              title="Sponsor 3 image"
              placeholder="Not specified"
              v-model="manufacturer.mfr.sponsor3_image"
            />
          </div>
        </template>
      </AppCard>
      <AppCard
        :mode="mode"
        title="Other"
        :isCenter="false"
        :isSmallTitle="true"
      >
        <template #body>
          <AppInput
            :mode="mode"
            id="url"
            type="url"
            title="URL"
            placeholder="Not specified"
            v-model="manufacturer.mfr.url"
          />
        </template>
      </AppCard>
      <AppButton
        :title="type === 'edit' ? 'Update Manufacturer' : 'Add Manufacturer'"
        @action="handleManufacturer"
      />
    </div>
  </div>
</template>

<script>
import { useUserStore } from "@S/user";
import { useToastStore } from "@S/toast";
import { useLoaderStore } from "@S/loader";
import { useCountriesStore } from "@S/countries";
import ApiRequest from "@L/ApiRequest";
import { useGlobalErrorHandler } from "@L/errorHandler";
import Section from "@C/Common/Section.vue";
import AppCard from "@C/Common/AppCard.vue";
import AppInput from "@C/Form/AppInput.vue";
import AppSelect from "@C/Form/AppSelect.vue";
import AppButton from "@C/Common/AppButton.vue";

export default {
  name: "EditManufacturer",
  props: {
    type: {
      type: String,
      default: "edit",
    },
    mode: String,
  },
  components: {
    Section,
    AppCard,
    AppInput,
    AppSelect,
    AppButton,
  },
  setup() {
    const userStore = useUserStore();
    const toastStore = useToastStore();
    const loaderStore = useLoaderStore();
    const countriesStore = useCountriesStore();
    const { handleError } = useGlobalErrorHandler();
    return {
      userStore,
      toastStore,
      loaderStore,
      countriesStore,
      handleError,
    };
  },
  data() {
    return {
      id: "",
      manufacturer: {
        mfr: {
          abbr: "",
          buy_broadcast_email_login: null,
          buy_broadcast_email_password: null,
          cat: 1,
          company: "",
          country: "",
          mfr: "",
          mfr_id: "",
          nmfr_id: 0,
          sell_broadcast_email_login: null,
          sell_broadcast_email_password: null,
          sponsor1_image: "",
          sponsor1_name: null,
          sponsor1_url: "",
          sponsor2_image: "",
          sponsor2_name: null,
          sponsor2_url: null,
          sponsor3_image: "",
          sponsor3_name: null,
          sponsor3_url: "",
          state: "",
          url: "",
        },
      },
      states: [],
      debounceTimer: null,
      zip: "",
    };
  },
  created() {
    if (!this.isAdmin) {
      this.toastStore.show(
        "You do not have permission to see this page",
        "error",
      );
      this.$router.push({ name: "home" });
      return;
    }
    if (this.type === "edit") {
      this.id = this.$route.params.id;
    }
  },
  mounted() {
    if (this.type === "edit") {
      this.getManufacturer();
    }
  },
  methods: {
    async getManufacturer() {
      this.loaderStore.setIsLoading(true);
      try {
        const { data } = await ApiRequest().get(`/mfr/${this.id}`);
        if (data) {
          this.manufacturer = data;
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
    async handleManufacturer() {
      this.loaderStore.setIsLoading(true);
      try {
        const { data } = await ApiRequest().post(`/mfr`, this.manufacturer);
        if (data) {
          this.toastStore.show(
            `Manufacturer ${
              this.type === "edit" ? "updated" : "addded"
            } successfully!`,
            "success",
          );
          if (this.type === "add") {
            this.$router.push({ name: "manufacturers" });
          }
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
    async getLocations() {
      if (!this.manufacturer.mfr.country || !this.zip) {
        this.states = [];
        return;
      }
      try {
        const payload = {
          country_code: this.$getCountryCode(
            this.countries,
            this.manufacturer.mfr.country,
          ),
          postal_code: this.zip,
        };
        const response = await fetch("/public_api/postal_codes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          this.toastStore.show("Failed to fetch location data", "error");
          return;
        }
        const data = await response.json();
        if (!data) {
          this.toastStore.show("No location data found", "error");
          this.states = [];
          return;
        }
        const statesMap = new Map();
        data.forEach((item) => {
          const source = item._source;
          if (source.admin_code1) {
            statesMap.set(source.admin_code1, {
              code: source.admin_code1,
              name: source.admin_name1 || source.admin_code1,
            });
          }
        });
        this.states = Array.from(statesMap.values());
      } catch (e) {
        this.handleError(e);
        this.states = [];
      }
    },
    debouncedGetLocations() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.getLocations();
      }, 500);
    },
  },
  watch: {
    "manufacturer.mfr.country": function (newVal) {
      if (newVal && this.zip) {
        this.debouncedGetLocations();
      }
    },
    zip: function (newVal) {
      if (newVal && this.manufacturer.mfr.country) {
        this.debouncedGetLocations();
      }
    },
  },
  computed: {
    countries() {
      return this.countriesStore.countries;
    },
    isAdmin() {
      return this.userStore.user.global_admin;
    },
  },
};
</script>
